import React, { createContext, useContext } from 'react';
import { Provider } from 'react-redux';
import { AppStore } from './store/checkoutStore.ts'; // Importiere den Typ des Stores

// Typisierter Kontext
const ReduxCheckoutContext = createContext<AppStore | null>(null);

interface ReduxCheckoutProviderProps {
  store: AppStore;
  children: React.ReactNode;
}

export const ReduxCheckoutProvider: React.FC<ReduxCheckoutProviderProps> = ({ store, children }) => (
  <ReduxCheckoutContext.Provider value={store}>
    <Provider store={store}>{children}</Provider>
  </ReduxCheckoutContext.Provider>
);

export const useReduxStore = (): AppStore => {
  const store = useContext(ReduxCheckoutContext);
  if (!store) {
    throw new Error('useReduxStore must be used within a ReduxCheckoutProvider');
  }
  return store;
};